import {
  ReactNode,
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { cookieUtils } from "../utils/cookieUtils";

type Language = "english" | "hindi" | "marathi";

const LanguageContext = createContext<[Language, (lang: Language) => void]>([
  "english",
  (_) => {},
]);

export function LanguageContextProvider({
  defaultValue,
  children,
}: {
  children: ReactNode | ReactNode[];
  defaultValue: Language;
}) {
  // const [lang, setLang] = useState<Language>(defaultValue);
  const [lang, setLang] = useState<Language>(() => {
    const storedLang = cookieUtils.getSecureCookie('defaultLang') as Language;
    return storedLang || defaultValue;
  });

  // const onChange = (lang: Language) => {
  //   localStorage.defaultLang = lang;
  //   setLang(lang);
  // };

  useEffect(() => {
    // Update cookie when language changes
    cookieUtils.setSecureCookie('defaultLang', lang);
  }, [lang]);

  const onChange = useCallback((newLang: Language) => {
    setLang(newLang);
  }, []);
  return (
    <LanguageContext.Provider value={[lang, onChange]}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext)[0];
}

export function useSetLanguage() {
  return useContext(LanguageContext)[1];
}

export function useGetFieldLabel() {
  const lang = useLanguage();
  return useCallback(
    (arg: { label: string; labelHindi?: string; labelMarathi?: string }) => {
      switch (lang) {
        case "hindi":
          return arg.labelHindi || arg.label;
        case "marathi":
          return arg.labelMarathi || arg.label;
        default:
          return arg.label;
      }
    },
    [lang]
  );
}
export function useGetFieldPlaceholder() {
  const lang = useLanguage();
  return useCallback(
    (arg: { placeholder?: string }) => {
      switch (lang) {
        case "hindi":
        case "marathi":
          return "";
        default:
          return arg.placeholder || "";
      }
    },
    [lang]
  );
}

export function assertValidLanguage(r: string): r is Language {
  return ["hindi", "english", "marathi"].includes(r);
}
